import Discover from './Discover'

export default Discover
